import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import doubtsService from "./doubtsService";

const initialState = {
  doubts: [],
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

export const getDoubts = createAsyncThunk("api/doubts/", async (thunkAPI) => {
  try {
    return await doubtsService.getDoubts();
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const doubtsSlice = createSlice({
  name: "doubts",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDoubts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDoubts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.doubts = action.payload;
      })
      .addCase(getDoubts.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const { reset } = doubtsSlice.actions;
export default doubtsSlice.reducer;
